<template>
  
      <div class="card mt-3" style="max-width: 800px;">
        <h5 class="modal-title p-2">Put Away Inbound {{ order.number }}</h5>
        <div class="p-0" id="put-away">
          <table class="table m-0" 
            v-for="(item, index) in order.items" :key="index"
          >
            <tr>
              <td style="width: 33%"
              >
                {{ item.product.sku }}<br />
                {{ item.product.name }}<br />
                <br />
                Putting Away: 
                <strong>{{ groupedPutItems[item.id].reduce((acc, itemr) => acc + (parseInt(itemr.qty_put_away) || 0 ), 0) }}
                          of {{ item.qty_received }}</strong>
              </td>
              <td class="text-right p-0">
                <table class="m-0 ml-auto table-borderless mb-0">
                  <tbody>
                    <tr
                      v-for="(item, i) in groupedPutItems[item.id]" :key="'bin' + i"
                    >
                      <td class="text-right">
                        <input 
                          type="number" 
                          v-model="item.qty_put_away"
                          class="form-control form-control-sm"
                          style="width: 100px;"
                        />
                      </td>
                      <td>IN</td>  
                      <td>
                        <input
                          type="text" 
                          placeholder="Location"
                          v-model="item.bin"
                          class="form-control form-control-sm"
                        />
                      </td>
                    </tr>
                  </tbody> 
                  <tfoot class="border-0">
                    <tr class="border-0">
                      <td></td>
                      <td></td>
                      <td>
                        <button @click="addPutItem(item)" class="btn btn-sm btn-light">
                          <i class="fa fa-plus"></i> Add
                        </button>                         
                      </td>
                    </tr>
                  </tfoot>
                </table>                    
              </td>
            </tr>
          </table>
        </div>
        <div class="modal-footer">      
          <div class="alert alert-danger" v-if="!valid">
            All fields are required!
          </div>            
          <button :disabled="!valid || submited" type="button" class="btn btn-primary" @click="submit">
            <i class="fa fa-check"></i> Put Away
          </button>
        </div>
      </div>

</template>

<script>
import api from '@/api'
import groupBy from 'lodash/groupBy'

export default {
  name: 'put-away',
  
  data() {
    return {
      order: { items: [] },
      submited: false,
      putItems: [],
      bins: [],
      users: [],
    }
  },

  created() {
    this.fetchData()
  },

  mounted() {
    setTimeout(() => {
      this.showCartons = true
    }, 500)
  },

  computed: {
    valid() {
      let valid = true
      this.params.forEach(p => {
        if (!p.bin) {
          valid = false
        }
      })

      return valid
    },

    params() {
      return this.putItems.map(item =>({
        id: item.id,
        bin: item.bin,
        qty_put_away: item.qty_put_away
      }))
    },

    groupedPutItems() {
      return groupBy(this.putItems, 'id')
    },

  },

  methods: {
    
    addPutItem(item) {
      let newItem = Object.assign({}, item)

      let totalQtyPut = this.groupedPutItems[item.id].reduce((acc, itemr) => acc + parseInt(itemr.qty_put_away), 0)
      newItem.qty_put_away = item.qty - totalQtyPut
      this.putItems.push(newItem)
    },

    submit() {
      if (this.valid) {
        // this.submited = true
        api.post(`/inbound-orders/${this.$route.params.id}/put-away-cases`, { cases: this.params }).then(() => {
          this.$router.push(`/inbound/${this.$route.params.id}`)
        })
      }
    },

    fetchData() {
      api.get(`/inbound-orders/${this.$route.params.id}`).then(res => {
        this.order = res.data.order
        this.putItems = this.order.items.map(item => {
          item.qty_put_away = item.qty
          return item
        })
      })

      api.get('/bins').then(res => {
        this.bins = res.data.bins
      })

      api.get('/users').then(res => {
        this.users = res.data.users
      })
    }
  }
}
</script>

<style scoped>

</style>